import React from "react";
// react components used to create a google map
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
};

const RegularMap = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={17}
            defaultCenter={{ lat: 35.10906, lng:33.333941 }}
            defaultOptions={{
                scrollwheel: false,
                streetViewControl: false,
                scaleControl: false,
                mapTypeControl: false,
                panControl: false,
                rotateControl: false,
                fullscreenControl: false
            }}
        >
            <Marker position={{ lat: 35.109830, lng:33.33441}} />
        </GoogleMap>
    ))
);

class GoogleMaps extends React.Component {
    render() {
        return (
            <div style={{ height: `100%`, width:`100%` }}>
                <RegularMap
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAWd2-RXMzXNacmlghy8Z1SmpK2-mnuO4o&callback=console.debug&libraries=maps,marker&v=beta&signature=FF2Y8PDO2GLF7XsImaXUsQsd3Fo="
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={
                        <div
                            style={{
                                height: `100%`,
                                minWidth: `100%`,
                                borderRadius: "6px",
                                overflow: "hidden"
                            }}
                        />
                    }
                    mapElement={<div style={{ height: `100%`, width:`100%` }} />}
                />
            </div>
        );
    }
}

export default withStyles(styles)(GoogleMaps);
